import type { ReactNode } from 'react';
export function Show({
  when,
  children
}: {
  when?: boolean;
  children: ReactNode;
}) {
  if (when) {
    return <>{children}</>;
  }
  return null;
}